import { useMemo } from 'react';
import { ApiErrorResponse } from '../models';

export function useErrorMessageOnEntityView(
  error: any,
  defaultErrorMessage: string,
) {
  return useMemo(() => {
    if (!error) {
      return '';
    }

    if ((error as ApiErrorResponse)?.status === 404) {
      return 'Common.errorNotFound';
    }

    return defaultErrorMessage;
  }, [error, defaultErrorMessage]);
}
